import SimpleParser from "./SimpleParser";

class DefaultParsersFactory {
	initialParser() {
		return new SimpleParser();
	}
}

export default DefaultParsersFactory;
